export const pieChartOptions = {
    dataLabels: {
        enabled: true,
        formatter: function(val) {
            return val + "%"
        },
    },
}

export const areaChartOptions = {
    xaxis: {
        // type: "datetime", 
        type: 'category',
        title: {
            text: 'Date',
        }
    },
    yaxis: {
        title: {
            text: 'Values',
        },
    },
    tooltip: {
        shared: true,
    }
};

export const columnchartOptions = {
    chart: {
        type: 'bar'
    },
    xaxis: {
        type: 'category',
        title: {
            text: 'Projects',
        }
    },
    yaxis: {
        title: {
            text: 'Likes',
        },
    },
}

export const rowchartOptions = {
    chart: {
        type: 'bar'
    },
    plotOptions: {
        bar: {
            horizontal: true
        }
    },
}